// Embudos · constantes compartidas.
import { ClipboardList, FileText, Globe, KanbanSquare } from "lucide-react";

export const STEP_ICON = { landing: Globe, form: FileText, survey: ClipboardList, pipeline: KanbanSquare } as const;
export const STEP_LABEL: Record<string, string> = { landing: "Landing page", form: "Formulario", survey: "Encuesta", pipeline: "Pipeline de ventas" };
